// for salary details of employee

export const RESER_EMPLOYEE_SALARY_DETAILS = "resign_employee_salary_details";
export const EMPLOYEE_SALARY_DETAILS = "employee_salary_details";
export const EMPLOYEE_SALARY_DETAILS_SUCCESS = "employee_salary_details_success";
export const EMPLOYEE_SALARY_DETAILS_FAILURE = "employee_salary_details_failure";
